export const useUser = () => {
  const { $gaApp } = useNuxtApp()

  const userData = computed(() => $gaApp.stores.main.user.data)
  const userIsBot = computed(() => $gaApp.stores.main.user.isBot)
  const userIsAuth = computed(() => $gaApp.stores.main.user.isAuthorized)

  return {
    userData,
    userIsBot,
    userIsAuth,
  }
}
